export default __webpack_public_path__ + "static/media/flag-usa-active.246bb4e9.svg";